import { render, staticRenderFns } from "./ChatForm.vue?vue&type=template&id=49ab64a7&scoped=true&"
import script from "./ChatForm.vue?vue&type=script&lang=js&"
export * from "./ChatForm.vue?vue&type=script&lang=js&"
import style0 from "./ChatForm.vue?vue&type=style&index=0&id=49ab64a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ab64a7",
  null
  
)

export default component.exports